import { createContext, useContext } from 'react';

const BuilderModeV1IndicatorIconContext = createContext(false);

export const BuilderModeV1IndicatorIconProvider = BuilderModeV1IndicatorIconContext.Provider;

export function useBuilderModeV1IndicatorIcons(): boolean {
  return useContext(BuilderModeV1IndicatorIconContext);
}
